onComplete(function() {
	// The old site stacked album photos in the shortest of three columns. Heights come from the width/height
	// attributes, so the layout is right before the lazy images have loaded.
	function buildMasonry(album) {
		if (album.querySelector('.masonry')) {
			return;
		}
		var items = Array.prototype.slice.call(album.querySelectorAll(':scope > .image-album-item'));
		if (items.length === 0) {
			return;
		}
		var wrapper = document.createElement('div');
		wrapper.className = 'masonry';
		var columns = [];
		var heights = [];
		for (var i = 0; i < 3; i++) {
			var column = document.createElement('div');
			column.className = 'masonry-column';
			wrapper.appendChild(column);
			columns.push(column);
			heights.push(0);
		}
		items.forEach(function(item) {
			var image = item.querySelector('img');
			var ratio = image && image.getAttribute('width') ? image.getAttribute('height') / image.getAttribute('width') : 1;
			var shortest = heights.indexOf(Math.min.apply(null, heights));
			columns[shortest].appendChild(item);
			heights[shortest] += ratio;
		});
		album.appendChild(wrapper);
	}

	function buildAll() {
		var mode = document.documentElement.getAttribute('data-editor-mode') || document.body.getAttribute('data-editor-mode');
		if (mode === 'content' || mode === 'layout') {
			return;
		}
		document.querySelectorAll('.album-images, .blog-template-classic.blog-item [data-partial="image-album"]').forEach(function(album) {
			var root = album.classList.contains('row') ? album : album.querySelector('.row') || album;
			buildMasonry(root);
		});
	}

	// The old site gave every project card title, every card intro and both service texts on the home page the
	// height of the tallest one in their group.
	function equalizeCards() {
		['.blog-item-preview .title', '.blog-item-preview-intro', '.service-card-text'].forEach(function(selector) {
			var elements = Array.prototype.slice.call(document.querySelectorAll(selector));
			elements.forEach(function(element) {
				element.style.minHeight = '';
			});
			if (window.innerWidth < 768) {
				return;
			}
			var tallest = Math.max.apply(null, elements.map(function(element) {
				return element.offsetHeight;
			}).concat([0]));
			elements.forEach(function(element) {
				element.style.minHeight = tallest + 'px';
			});
		});
	}

	// The CMS bases the image sizes on a fixed screen fraction, which is too small for photos that span the
	// full width on mobile. Photos that fill their box get the measured width (covered photos need their height times the aspect).
	function fitSizes() {
		document.querySelectorAll('#page main picture').forEach(function(picture) {
			var img = picture.querySelector('img');
			var box = picture.parentElement;
			if (!img || !box) {
				return;
			}
			var rect = img.getBoundingClientRect();
			var boxStyle = getComputedStyle(box);
			var boxWidth = box.clientWidth - parseFloat(boxStyle.paddingLeft) - parseFloat(boxStyle.paddingRight);
			if (!rect.width || rect.width < boxWidth - 1) {
				return;
			}
			var width = rect.width;
			var ratio = img.getAttribute('width') && img.getAttribute('height') ? img.getAttribute('width') / img.getAttribute('height') : 0;
			if (ratio && getComputedStyle(img).objectFit === 'cover') {
				width = Math.max(width, rect.height * ratio);
			}
			var sizes = Math.ceil(width) + 'px';
			picture.querySelectorAll('source, img').forEach(function(source) {
				if (source.getAttribute('sizes') !== sizes) {
					source.setAttribute('sizes', sizes);
				}
			});
		});
	}

	buildAll();
	equalizeCards();
	fitSizes();
	window.addEventListener('load', fitSizes);
	window.addEventListener('resize', fitSizes);
	window.addEventListener('resize', equalizeCards);
	// The project overview loads more cards while scrolling; those get the same height too.
	document.querySelectorAll('.blog-collection-items, .blog-related').forEach(function(list) {
		new MutationObserver(function() {
			equalizeCards();
			fitSizes();
		}).observe(list, { childList: true, subtree: true });
	});
	if (document.fonts) {
		document.fonts.ready.then(equalizeCards);
	}

	// Logged in, the editor reloads all partials after start-up; rebuild on its events.
	if (document.getElementById('adminbar')) {
		var tries = 0;
		var wait = setInterval(function() {
			tries++;
			if (window.editor && window.editor.addEventListener) {
				clearInterval(wait);
				window.editor.addEventListener('reloaded', function() {
					buildAll();
					fitSizes();
				});
				window.editor.addEventListener('changed-mode', function() {
					buildAll();
					fitSizes();
				});
			} else if (tries > 40) {
				clearInterval(wait);
			}
		}, 250);
	}
});
